import styled, { keyframes } from 'styled-components';
export const Container = styled.div `
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    pointer-events: none;
`;
const spin = keyframes `
    0% { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
`;
export const LoaderContainer = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 150px;
    opacity: ${(props) => (props.displayed ? 1 : 0)};
    animation: ${(props) => (props.displayed ? spin : 'none')} 1s ease-in-out infinite;
    transition: opacity 200ms ease-in-out;

    & path {
        stroke-width: 0.1px;
    }

    & img {
        display: block;
    }
`;
//# sourceMappingURL=index.js.map